export function isInsufficientGiftBalancePacket(packet: any): boolean {
	if (!packet || packet.success !== false) {
		return false;
	}

	const topLevelError = packet.error;
	const nestedError = packet.data?.error;
	const errorObject =
		topLevelError && typeof topLevelError === 'object' ? topLevelError : nestedError || undefined;
	const errorMessage =
		typeof topLevelError === 'string'
			? topLevelError
			: errorObject?.message || nestedError?.message || '';
	const errorCode = errorObject?.code;

	if (errorCode === 14 || errorCode === 27 || errorCode === 34) {
		return true;
	}

	return /insufficient|not enough balance|not enough chips/i.test(String(errorMessage));
}
